<template>
  <div>
    <div>
      <img src="@/assets/images/payBanner.png" class="pay-banner" />
      <p class="pay-banner-name">
        {{ user.name }}&nbsp;&nbsp;{{ user.gender }}
      </p>
      <p class="pay-banner-suntime">
        {{ user.birthday[0] }}年{{ user.birthday[1] }}月{{ user.birthday[2] }}日
      </p>
      <p class="pay-banner-moontime">
        {{ lunar.year }}年{{ lunar.month }}月{{ lunar.day }}日
      </p>
      <div class="goods" style="background: #F8DDAE">
        <div class="goods-title">
          <b style="color:#301006;"
            >已有{{ count }}人进行测试，<span style="color:#c02427;">97％</span
            >的用户认为本姓名测算对了解个人命运有很大帮助。</b
          >
          <p style="padding: 4px 0">
            <b style="color:#301006;"
              >找出姓名中的优势和不足，让您轻松掌握自己一生命运！</b
            >
          </p>
        </div>
        <div class="order-money">
          <p class="order-money-title">测算项目：在线付费_姓名测算</p>
          <div class="lf money-show">
            <span>限时优惠￥{{ price }}元</span>
          </div>
          <div class="rt">距优惠结束</div>
          <div class="lf money-show"><s>原价：￥139</s></div>
          <div class="time rt">
            <span id="t_h"></span>： <span id="t_m"></span>：
            <span id="t_s"></span>
          </div>
          <div class="clear"></div>
        </div>
        <div class="order-money2">
          <div class="order-list">
            <ul>
              <li>
                <img src="@/assets/images/wxplay.png" width="30px" /><span
                  >微信支付</span
                >
                <div class="pay-choose"></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="goods-go-pay-btn" v-on:click="submit()">立即下单</div>
        <img
          src="@/assets/images/hide-result-title-lock.png"
          class="result-title"
          style="width: 100%;position: inherit;display: block;margin: 5% auto 0"
        />
      </div>
      <div class="blackBg" ontouchstart="this.style.display = 'none';"></div>
      <div id="hideResult">
        <div class="gosee-message-container" style="line-height: 27px;">
          <img
            src="@/assets/images/xpzz.png"
            class="imTU"
            style="width: 100%"
          />
          <div class="gosee-message">
            <img
              src="@/assets/images/xmxx.png"
              class="imTU"
              style="width: 100%"
            />
            <div style="padding: 0 0 2%;">
              <div>
                <div class="resultContentborder-l">
                  <span>{{ simpleResult.resultname }}</span
                  ><br />
                  <span>{{ simpleResult.resultxs }}</span
                  ><br />
                </div>
                <div class="resultContentborder-r">
                  <span>{{ simpleResult.resultsnny }}</span
                  ><br />
                  <span>{{ simpleResult.resultzygx }}</span
                  ><br />
                </div>
                <div class="resultContentborder-l1">
                  <div
                    v-for="(item, index) in simpleResult.flnameList"
                    :key="index"
                  >
                    <span class="pl4">{{ item }}</span>
                  </div>
                </div>
                <div class="resultContentborder-r1">
                  <div
                    v-for="(item, index) in simpleResult.bihuaList"
                    :key="index"
                  >
                    <span class="pl4">{{ item }}</span>
                  </div>
                </div>
                <span class="pl4">{{ simpleResult.resulttg }}</span
                ><br />
                <span class="pl4">{{ simpleResult.resultrg }}</span
                ><br />
                <span class="pl4">{{ simpleResult.resultdg }}</span
                ><br />
                <span class="pl4">{{ simpleResult.resultwg }}</span
                ><br />
                <span class="pl4">{{ simpleResult.resultzg }}</span
                ><br />
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div
          class="gosee-message-title"
          v-for="(item, index) in simpleResult.showListConent"
          :key="index"
        >
          <div class="careerLuckTitle">
            <p class="gosee-message-small-title">
              <img :src="getTitleImg(item.title)" style="width:100%;" />
            </p>
            <p class="gosee-message-small-message">
              {{ item.message }}......<img
                src="@/assets/images/lock.png"
                v-if="!item.describe"
                style="width: 15px"
              />
            </p>

            <div class="analyseBg" v-if="item.describe">
              <span class="feng">封</span>
              <div class="analyseBox">
                <div class="careerLuckHide" style="background: #F8EBCC">
                  <p class="tips hide-tips" v-html="item.describe"></p>
                  <p class="hideResultBtn" v-on:click="submit()">
                    解锁全部内容
                    <img src="@/assets/images/lock.png" class="lock" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gosee-message-title">
          <div class="careerLuckTitle">
            <p class="gosee-message-small-title">
              <img src="@/assets/images/ywqm.png" style="width:100%;" />
            </p>
            <div class="analyseBg">
              <span class="feng">封</span>
              <div class="analyseBox" style="position: relative;">
                <img
                  src="@/assets/images/hide-english-one.png"
                  style="width: 100%;margin-bottom: 15px"
                  v-on:click="submit()"
                />
                <p class="englishName">
                  {{ simpleResult.englishName.name }}??????
                </p>
                <img
                  src="@/assets/images/hide-english-two.png"
                  style="width: 100%;margin-bottom: 15px"
                  v-on:click="submit()"
                />
                <img
                  src="@/assets/images/hide-english-three.png"
                  style="width: 100%;margin-bottom: 15px"
                  v-on:click="submit()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="@/assets/images/bgTitle.png" class="bgTitle" />
      <div class="commentShow imMar">
        <p class="CommentOne">
          已有<span>{{ count }}</span
          >人进行测试，<span class="textRed">97%</span>的用户认为很准
        </p>
        <p class="CommentTwo">
          由占卜大师吴明光及所在团队桃桃喜倾力打造，质量保障，请放心购买。
        </p>
        <img src="@/assets/images/fiveImStar.png" class="percent" />
        <div>
          <div class="commentBg">
            <img src="@/assets/images/comment1.png" />
            <img src="@/assets/images/comment2.png" />
            <img src="@/assets/images/comment3.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="line-scale" v-show="isLoading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="article-call" v-on:click="linkToService()">
      <p>如果需要帮助，请点击此处联系我们的</p>
      <p class="callSer">我们的售后客服</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../store'

import { Base64 } from 'js-base64'
import { mapState } from 'vuex'

import { FORTUNE_GETTERS } from '../store/modules/fortune-getters-types'

import share from '../share'

export default {
  name: 'Preview',
  data() {
    return {
      lunar: {},
      simpleResult: { englishName: { name: null } },
      paymentLoadingCount: 0
    }
  },
  beforeRouteEnter(to, from, next) {
    if (Object.entries(store.state.fortune.request).length === 0) {
      next({ name: 'Home' })
    } else {
      next()
    }
  },
  mounted: function() {
    localStorage.setItem(
      'previewRequest',
      JSON.stringify(this.$store.state.fortune.request)
    )
    document.documentElement.scrollTop = 0
    let payload = {}
    payload.ttxid = this.$store.state.user.ttxid
    payload.timestamp = this.$store.state.user.timestamp
    payload.token = this.$store.state.user.token
    this.$store.dispatch('fortune/getSimpleResult', payload).then(
      res => {
        countdown()
        if (res.ans == '无法辨识') {
          alert('对不起,“' + this.user.name + '”这个名字无法辨识')
        } else {
          this.simpleResult = resultProcess(res)
        }
      },
      err => {
        alert('对不起,“' + this.user.name + '”这个名字无法辨识')
        this.$router.push({ name: 'Home' })
      }
    )

    payload = {}
    payload.solar = new Date(
      this.$store.state.fortune.request.birthday.toString()
    ).getTime()
    this.$store.dispatch('fortune/getLunarDate', payload).then(
      res => {
        this.lunar = res
      },
      err => {
        this.lunar.year = 0
        this.lunar.month = 0
        this.lunar.day = 0
      }
    )
    try {
      TtxTrack.track('xing-ming-v2', 'FORTUNE_SIMPLERESULT')
    } catch (e) {
      // console.log(e)
    }
  },
  methods: {
    linkToService: function() {
      this.$router.push({ name: 'Service' })
    },
    getTitleImg: function(filename) {
      return require('../assets/images/' + filename + '.png')
    },
    submit: async function() {
      let payload = {}
      payload.ttxid = this.$store.state.user.ttxid
      payload.timestamp = this.$store.state.user.timestamp
      payload.token = this.$store.state.user.token

      this.paymentLoadingCount++
      try {
        if (share.isWeixin()) {
          let chargeResp = await axios.post(
            'https://api.taotaoxi.cn/payment/wechat/jsapi/charge?ttxid=' +
              payload.ttxid +
              '&timestamp=' +
              payload.timestamp +
              '&token=' +
              payload.token,
            {
              product: [
                { id: this.$store.state.fortune.data.weChatId, quantity: 1 }
              ],
              appId: 'wxa2acc77c8368a9dc',
              subject: this.user.name + '的三千字姓名测算详批'
            }
          )
          payload.orderNo = chargeResp.data.orderNo
          try {
            TtxTrack.track('xing-ming-v2', 'FORTUNE_PAY')
          } catch (e) {
            // console.log(e)
          }
          this.$store.dispatch('fortune/postQuizData', payload).then(res => {
            // jump to wx jsapi payment
            let successUrl = Base64.encodeURI(
              'http://' +
                location.host +
                '/result/' +
                chargeResp.data.orderNo +
                '?channel=' +
                this.channel
            )
            let failUrl = Base64.encodeURI(
              location.href + '?channel=' + this.channel
            )
            let charge = Base64.encodeURI(
              unescape(encodeURIComponent(JSON.stringify(chargeResp.data)))
            )
            location.replace(
              'https://shared-resource.taotaoxi.net/wx-pub-pay/?charge=' +
                charge +
                '&success_next=' +
                successUrl +
                '&fail_next=' +
                failUrl
            )
          })
        } else {
          let chargeResp = await axios.post(
            'https://api.taotaoxi.cn/payment/wechat/h5/charge?ttxid=' +
              payload.ttxid +
              '&timestamp=' +
              payload.timestamp +
              '&token=' +
              payload.token,
            {
              product: [
                { id: this.$store.state.fortune.data.weChatH5Id, quantity: 1 }
              ],
              appId: 'wxa2acc77c8368a9dc',
              subject: this.user.name + '的三千字姓名测算详批'
            }
          )
          payload.orderNo = chargeResp.data.orderNo
          try {
            TtxTrack.track('xing-ming-v2', 'FORTUNE_PAY')
          } catch (e) {
            // console.log(e)
          }
          this.$store.dispatch('fortune/postQuizData', payload).then(res => {
            // jump to wx h5 payment
            let redirectUrl =
              'https://' +
              location.host +
              '/xing-ming-ce-suan/' +
              chargeResp.data.orderNo +
              '?channel=' +
              this.channel
            location.replace(
              chargeResp.data.link +
                '&redirect_url=' +
                encodeURIComponent(redirectUrl)
            )
          })
        }
      } catch (err) {
      } finally {
        this.paymentLoadingCount--
      }
    }
  },
  computed: {
    ...mapState('fortune', {
      channel: 'channel',
      count: 'count',
      isLoading: function(state) {
        return state.loadingCount + this.paymentLoadingCount > 0
      },
      price: function(state) {
        if (share.isWeixin()) {
          return state.data.price
        } else {
          return state.data.priceH5
        }
      }
    }),
    user: function() {
      let user = {}
      user.name = this.$store.state.fortune.request.userName
      user.birthday = this.$store.state.fortune.request.birthday.split('-')
      user.genderText =
        this.$store.state.fortune.request.gender == 1 ? '男' : '女'
      return user
    }
  }
}

let resultProcess = function(data) {
  let result = {}
  result.lifeAnalyze = data.lifeAnalyze
  result.resultname = data.lifeAnalyze[0]
  result.resultsngz = data.lifeAnalyze[1]
  result.resultsx = data.lifeAnalyze[2]
  result.resultsnny = data.lifeAnalyze[3]
  result.resultxs = data.lifeAnalyze[4]
  result.resultzygx = data.lifeAnalyze[5]
  result.englishName = data.englishName

  /*计算名字所在i*/
  var trdwgList = []
  var nameList = []
  var bihuaList = []
  var flnameList = []
  //切出多余
  for (var i = 0; i < data.lifeAnalyze.length; i++) {
    if (data.lifeAnalyze[i].substring(2, 0) == '天格') {
      result.resulttg = data.lifeAnalyze[i]
      trdwgList.push(i)
    } else if (data.lifeAnalyze[i].substring(2, 0) == '人格') {
      result.resultrg = data.lifeAnalyze[i]
      trdwgList.push(i)
    } else if (data.lifeAnalyze[i].substring(2, 0) == '地格') {
      result.resultdg = data.lifeAnalyze[i]
      trdwgList.push(i)
    } else if (data.lifeAnalyze[i].substring(2, 0) == '外格') {
      result.resultwg = data.lifeAnalyze[i]
      trdwgList.push(i)
    } else if (data.lifeAnalyze[i].substring(2, 0) == '總格') {
      result.resultzg = data.lifeAnalyze[i]
      trdwgList.push(i)
    }
    if (i > 5) {
      nameList.push(i)
    }
  }
  //计算姓名笔画
  for (var i = 0; i < nameList.length; i++) {
    for (var j = 0; j < trdwgList.length; j++) {
      if (trdwgList[j] == nameList[i]) {
        nameList.splice(i, 1)
      }
    }
  }
  //切出姓名/笔画
  for (var i = 0; i < nameList.length; i++) {
    // nameList.splice(i, 1, userList.lifeAnalyze[nameList[i]]);
    if (data.lifeAnalyze[nameList[i]].length == 1) {
      flnameList.push(data.lifeAnalyze[nameList[i]])
    } else {
      bihuaList.push(data.lifeAnalyze[nameList[i]])
    }
  }
  result.flnameList = flnameList
  result.bihuaList = bihuaList
  result.showListConent = [
    {
      title: 'gxjs',
      message: data.answerList[0].contents[0]
    },
    {
      title: 'gqfx',
      message: data.answerList[1].contents[0],
      describe:
        '从<span>生肖角度</span>分析最适合的感情模式，<span>帮助你找到最合拍伴侣。</span>'
    },
    {
      title: 'cyfx',
      message: data.answerList[2].contents[0],
      describe:
        '从<span>生肖、姓名学</span>等全面分析你一生的正财运合偏财运，<span>预知自己的财富类型和等级。</span>'
    },
    {
      title: 'syfx',
      message: data.answerList[3].contents[0],
      describe:
        '从<span>阴阳五行、生肖、笔画多少</span>分析你的一生的工作优势，<span>预知自己的工作竞争力，为您出谋划策。</span>'
    },
    {
      title: 'rjgx',
      message: data.answerList[4].contents[0],
      describe:
        '由<span>阴阳五行、生肖</span>来分析你的贵人运和人缘，<span>提前获悉自己的人助力。</span>'
    },
    {
      title: 'jkfx',
      message: data.answerList[5].contents[0],
      describe:
        '由<span>阴阳五行、生肖和姓名学等综合分析</span>你的健康，全面了解自己身体的强项和不足，<span>预知自己的易发疾病高发期，提前防御。</span>'
    }
  ]
  return result
}

let countdown = function() {
  let EndTime = new Date().getTime() + 7200000

  function GetRTime() {
    var NowTime = new Date()
    var t = EndTime - NowTime.getTime()
    var h = 0,
      m = 0,
      s = 0
    if (t >= 0) {
      h = Math.floor((t / 1000 / 60 / 60) % 24)
      m = Math.floor((t / 1000 / 60) % 60)
      s = Math.floor((t / 1000) % 60)
    }
    try {
      document.getElementById('t_h').innerHTML = h
      document.getElementById('t_m').innerHTML = m
      document.getElementById('t_s').innerHTML = s
    } catch (ex) {
      clearInterval(GetRTimeInter)
    }
  }

  let GetRTimeInter = setInterval(GetRTime, 200)
}
</script>

<style scoped>
.article-call p:last-child {
  background: url('../assets/images/call.png') 0 0 no-repeat;
  background-size: 18%;
  display: inline-block;
  padding-left: 25px;
}
.commentShow {
  width: 96%;
  display: block;
  margin: 0 auto;
  padding: 5%;
  background: url('../assets/images/fiveIm.png') 0 0 no-repeat;
  background-size: 100% 100%;
  border: 1px solid transparent;
}
.goods-go-pay-btn {
  background: url('../assets/images/btnBg.png') 0 0 no-repeat;
  background-size: 100%;
  text-align: center;
  height: 50px;
  width: 80%;
  margin: 4% auto 0;
  line-height: 50px;
  color: #fff;
}
.pay-choose {
  width: 25px;
  height: 30px;
  float: right;
  background: url('../assets/images/pay-choose.png') 0 0 no-repeat;
  background-size: 100%;
  margin-top: 8px;
}
.careerLuckHide {
  border: 5px solid;
  border-image: url('../assets/images/case.png') 5;
  margin: 0 auto;
  padding: 5px;
  width: 90%;
}
</style>
